import { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const OrContentHeadingArea = ({ children }: Props) => {
  return <h1 className='orcontentheadingarea'>{children}</h1>;
};
/** 初期値の設定 */
export default OrContentHeadingArea;
